export const state = () => ({
  isDark: false, // 是否是暗黑模式
  keyword: '', // 搜索词
  showFooter: false, // 是否展示footer
  showNav: false, // 是否展示navbar
  userInfo: null,
  app: '', // 组件名
  source: 'questionmark', // 来源
});

export const mutations = {
  setDark(state, data) {
    state.isDark = data;
  },
  setKeyword(state, data) {
    state.keyword = data;
  },
  setShowFooter(state, data) {
    state.showFooter = data;
  },
  setUserInfo(state, data) {
    state.userInfo = data;
  },
  setApp(state, data) {
    state.app = data;
  },
  setShowNav(state, data) {
    state.showNav = data;
  },
  setSource(state, data) {
    state.source = data;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/common.js